import { render, staticRenderFns } from "./Qs.vue?vue&type=template&id=00bf523a&scoped=true&"
import script from "./Qs.vue?vue&type=script&lang=js&"
export * from "./Qs.vue?vue&type=script&lang=js&"
import style0 from "./Qs.vue?vue&type=style&index=0&id=00bf523a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf523a",
  null
  
)

export default component.exports